import { api } from "./api";

// Customer refill follow-ups (backend: /api/refill-followup)
const FOLLOW_UP_URL = "/refill-followup";

export const followUpListApi = (params) => api.get(FOLLOW_UP_URL, { params });

// The customer's pending items due by uptoDate, for the WhatsApp message
export const followUpCustomerItemsApi = (params) =>
  api.get(`${FOLLOW_UP_URL}/customer-items`, { params });

export const followUpStatusApi = (data) =>
  api.post(`${FOLLOW_UP_URL}/status`, data);

export const followUpCommentsApi = (rfu_id) =>
  api.get(`${FOLLOW_UP_URL}/comments`, { params: { rfu_id } });

export const followUpAddCommentApi = (data) =>
  api.post(`${FOLLOW_UP_URL}/comments`, data);

export const followUpSettingsApi = () => api.get(`${FOLLOW_UP_URL}/settings`);

export const followUpSettingsUpdateApi = (data) =>
  api.post(`${FOLLOW_UP_URL}/settings`, data);
